<template>
  <div class="blogroll_wrapper">
    <div class="item" v-for="(item, index) in list" :key="index">
      <img @click="tolink(item)" :src="picAddr + item.friendlinkpicpath" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  name: "Blogroll",
  data() {
    return {
      list: [],
      ww: window,
    };
  },
  computed: {
    ...mapGetters(["cosId", "picAddr"]),
  },
  created() {
    this.getList();
  },
  methods: {
    tolink(item) {
      // console.log(item)
      this.ww.open(item.friendlinkurl, "_blank");
      // tempwindow.location = item.friendlinkurl
    },
    async getList() {
      let res = await request({
        method: "get",
        url: "/web/web/getFriendlinkList",
        params: { friendlinkcosid: this.cosId },
      });
      this.list = res;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";
@media screen and (min-width: 1201px) {
  .blogroll_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    background-color: $color-bg-white;
    padding: 5px;
    .item {
      width: 18%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 11px;
      height: 68px;
      img {
        cursor: pointer;
        width: 100%;
        max-height: 68px;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .blogroll_wrapper {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .item {
      width: 9.5em;
      margin: 10px 15px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>